import type { ReactElement } from "react";

export function GettingStarted(): ReactElement {
  return (
    <>
      <h2>Boards</h2>
      <p>
        A board is one thread of work. You generate a frame, look at it, change something, and go
        again. The board keeps that sequence in order, so the run of attempts is the record — not a
        folder of files named after the time you made them.
      </p>
      <p>
        Frames are numbered per board, starting at <code>01</code>. The number is how you refer to
        one: a frame made by editing another says <em>from frame 02</em>.
      </p>

      <h2>The composer</h2>
      <p>
        The composer sits at the bottom of the board. Write what you want, pick a model, adjust
        parameters if you need to, and submit. Nothing else is required.
      </p>
      <ul>
        <li>A prompt is required and can be up to 8,000 characters.</li>
        <li>The model picker lists every model Darkroom knows about, grouped by provider.</li>
        <li>
          The parameters button shows how many settings differ from the model's defaults, and opens
          the controls for that model.
        </li>
      </ul>

      <h2>Mode is inferred, never chosen</h2>
      <p>
        There is no generate/edit switch. Attach reference images and the composer is editing;
        remove them and it is generating. The submit button names the action it is about to take,
        so what you are about to do is always on the button.
      </p>
      <p>
        If the selected model cannot edit while you have images attached, submit is disabled and
        says so, with the models that can do it one click away.
      </p>

      <h2>While it runs</h2>
      <p>
        Submitting queues the work on the server and returns straight away. The frame appears
        immediately as an empty plate with an elapsed timer, and fills in when the image comes back.
        These calls take anywhere from about ten seconds to two minutes.
      </p>

      <h2>Signing in</h2>
      <p>
        Darkroom uses Google sign-in and only accepts addresses on an allowlist held in the
        server's configuration. You see only your own boards and images.
      </p>
    </>
  );
}
